import { API } from "@/request/api"
export default {
  data() {
    return {
      sdkURL: '',
      callType: '',
      callOutRowId: '',
      callOutPhone: '',
      callInPhone: '',
    }
  },
  methods: {
    saveRowData(id, phone) {
      this.callOutRowId = id
      this.callOutPhone = phone
      console.log(`%cid, phone:`, 'color: #00f;', this.callOutRowId, this.callOutPhone)
    },
    // 生成一次呼出通话记录
    createCallOutHistory() {
      console.log(`%cid, phone:`, 'color: #00f;', this.callOutRowId, this.callOutPhone)
      API.addCallOutHistory({ id: this.callOutRowId, phone: this.callOutPhone })
    },
    // 生成一次呼入通话记录
    createCallInHistory() {
      API.addCallInHistory({ callingPhone: this.callInPhone })
    },
    // 获取腾讯云TCCC URL
    getTCCCUrl() {
      this.sdkURL = ''
      API.getTCCCUrl().then(async res => {
        if (res.data.status == 0) {
          if (!res.data.data) return
          let _R = JSON.parse(res.data.data)
          // console.log(`%c_R:`, 'color: #f00;', _R)
          this.sdkURL = _R.sdkURL
          await this.injectTcccWebSdk()
        } else { this._status(res.data) }
      })
    },
    // 初始化腾讯云TCCC
    injectTcccWebSdk() {
      if (this.sdkURL === '') return
      // console.log(window.tccc)
      if (window.tccc) return
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.setAttribute('crossorigin', 'anonymous')
        // console.log('script', script)
        // 需要渲染进的DomId，如果填写则没有悬浮窗，工作台直接渲染进指定的 dom 元素
        // 为保证工作台 UI 完整，渲染的 Dom 最小高度为480px，最小宽度为760px
        // script.dataset.renderDomId = "renderDom"
        script.src = this.sdkURL
        document.body.appendChild(script)
        script.addEventListener('load', () => {
          // 加载JS SDK文件成功，此时可使用全局变量"tccc"
          window.tccc.on(window.tccc.events.ready, () => {
            /**
            * Tccc SDK 初始化成功，此时可调用外呼、监听呼入事件等功能。
            * 注意⚠️：请确保只初始化一次 SDK
            * */
            resolve('初始化成功')
          })
          window.tccc.on(window.tccc.events.tokenExpired, ({message}) => {
            console.error('初始化失败', message)
            reject(message)
            this.injectTcccWebSdk()
          })
          window.tccc.on(window.tccc.events.callOuted, options => {
            console.log('callOuted', options, options.callerPhoneNumber, options.calleePhoneNumber)
            this.callType = 'out'
          })
          window.tccc.on(window.tccc.events.callIn, options => {
            console.log('callIn', options, options.callerPhoneNumber, options.calleePhoneNumber)
            this.callType = 'in'
            this.callInPhone = options.callerPhoneNumber
          })
          window.tccc.on(window.tccc.events.sessionEnded, options => {
            console.log('sessionEnded', options)
            switch (this.callType) {
              case 'out':
                this.createCallOutHistory()
                break;
              case 'in':
                this.createCallInHistory()
                break;
            }
          })
        })
      })
    },
  },
  created() {
    this.getTCCCUrl()
  },
}